/* eslint-disable import/no-extraneous-dependencies */
import { useEffect, useState, ReactNode } from 'react'
import { useBlocker } from 'react-router-dom'

type RenderProp = (props: {
  isActive: boolean
  onConfirm: () => void
  onCancel: () => void
}) => ReactNode

interface NavigationPromptProps {
  when: boolean
  message?: string
  children?: RenderProp | ReactNode
}

export default function NavigationPrompt({
  when,
  message = 'You have unsaved changes. Are you sure you want to leave?',
  children
}: NavigationPromptProps) {
  const [isActive, setIsActive] = useState(false)

  const blocker = useBlocker(when)

  useEffect(() => {
    if (blocker.state === 'blocked') {
      setIsActive(true)
    }
  }, [blocker.state])

  const onConfirm = () => {
    setIsActive(false)
    blocker.proceed?.()
  }

  const onCancel = () => {
    setIsActive(false)
    blocker.reset?.()
  }

  if (!children) {
    if (blocker.state === 'blocked') {
      const confirmed = window.confirm(message)
      if (confirmed) {
        blocker.proceed?.()
      } else {
        blocker.reset?.()
      }
    }
    return null
  }

  if (typeof children === 'function') {
    return <>{children({ isActive, onConfirm, onCancel })}</>
  }

  return <>{isActive && children}</>
}
